<template>
	<v-container class="outreach none-fluid link">
		<banner>University Administration Experience</banner>
		<div class="mx-auto">
			<div>
                <div v-html="$sanitize(content)"></div>
            </div>
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getAdministration } from "../../service/administration";

export default {
	components: {
		Banner
	},
	data() {
		return {
			content: {}
		};
	},
	mounted() {
		getAdministration()
			.then(data => {
				this.content = data
				console.log(this.content)
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>